// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1mQtL","footer":"ReportModalFilter_footer__5EyW9"};